// @ts-nocheck
import { safetyInitialApi as api } from './initialApi';
export const addTagTypes = [
  'safety-center-controller-v-2',
  'event-settings-controller',
  'driver-score-controller',
  'fleet-score-controller',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      retrieveSafetyEventsByTripIds: build.mutation<
        RetrieveSafetyEventsByTripIdsApiResponse,
        RetrieveSafetyEventsByTripIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-03-24/events/trips`,
          method: 'POST',
          body: queryArg.safetyTripEventsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['safety-center-controller-v-2'],
      }),
      getVehicleSettings: build.query<
        GetVehicleSettingsApiResponse,
        GetVehicleSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/2026-01-27/settings`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['event-settings-controller'],
      }),
      updateVehicleSettings: build.mutation<
        UpdateVehicleSettingsApiResponse,
        UpdateVehicleSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/2026-01-27/settings`,
          method: 'PATCH',
          body: queryArg.eventSettingsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['event-settings-controller'],
      }),
      retrieveEmergencyEventSummary: build.query<
        RetrieveEmergencyEventSummaryApiResponse,
        RetrieveEmergencyEventSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-08-25/events/emer-summary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventsV2: build.query<
        RetrieveSafetyEventsV2ApiResponse,
        RetrieveSafetyEventsV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-03-24/events`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            driverId: queryArg.driverId,
            searchKeyword: queryArg.searchKeyword,
            hasMedia: queryArg.hasMedia,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventDetailsById: build.query<
        RetrieveSafetyEventDetailsByIdApiResponse,
        RetrieveSafetyEventDetailsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-03-24/events/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventsForSelfV2: build.query<
        RetrieveSafetyEventsForSelfV2ApiResponse,
        RetrieveSafetyEventsForSelfV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-03-24/events/me`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            searchKeyword: queryArg.searchKeyword,
            hasMedia: queryArg.hasMedia,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      getDriverScoreDetailsForSelf: build.query<
        GetDriverScoreDetailsForSelfApiResponse,
        GetDriverScoreDetailsForSelfApiArg
      >({
        query: () => ({ url: `/2026-03-10/driver-scores/me` }),
        providesTags: ['driver-score-controller'],
      }),
      getVehicleScores: build.query<
        GetVehicleScoresApiResponse,
        GetVehicleScoresApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-02-24/vehicle-scores`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            vinSearch: queryArg.vinSearch,
            minScore: queryArg.minScore,
            maxScore: queryArg.maxScore,
            excludeNoScore: queryArg.excludeNoScore,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getDriverScoresSummary: build.query<
        GetDriverScoresSummaryApiResponse,
        GetDriverScoresSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-02-24/driver-scores-summary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getScore: build.query<GetScoreApiResponse, GetScoreApiArg>({
        query: (queryArg) => ({
          url: `/2025-11-18/fleet-performances`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['fleet-score-controller'],
      }),
      getDriverScores: build.query<
        GetDriverScoresApiResponse,
        GetDriverScoresApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/driver-scores`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            driverNameSearch: queryArg.driverNameSearch,
            minScore: queryArg.minScore,
            maxScore: queryArg.maxScore,
            minRank: queryArg.minRank,
            maxRank: queryArg.maxRank,
            excludeNoScore: queryArg.excludeNoScore,
            sortOrder: queryArg.sortOrder,
            sortBy: queryArg.sortBy,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getDriverScoreDetails: build.query<
        GetDriverScoreDetailsApiResponse,
        GetDriverScoreDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/driver-scores/${queryArg.driverScoreId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as safetyApi };
export type RetrieveSafetyEventsByTripIdsApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyTripEventsResponseDto
  | /** status 204 No Content */ GmResponseCommonSafetyTripEventsResponseDto
  | /** status 206 Partial Content */ GmResponseCommonSafetyTripEventsResponseDto;
export type RetrieveSafetyEventsByTripIdsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  safetyTripEventsRequestDto: SafetyTripEventsRequestDto;
};
export type GetVehicleSettingsApiResponse =
  /** status 200 Success */ GmResponseCommonEventSettingsDto;
export type GetVehicleSettingsApiArg = {
  /** Organization ID */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
};
export type UpdateVehicleSettingsApiResponse =
  /** status 200 Success */ GmResponseCommon;
export type UpdateVehicleSettingsApiArg = {
  /** Organization ID */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  eventSettingsRequest: EventSettingsRequest;
};
export type RetrieveEmergencyEventSummaryApiResponse =
  /** status 200 Success */ GmResponseCommonListSafetyApiEventTypeCountDto;
export type RetrieveEmergencyEventSummaryApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. Counts cover all fleets in the organization when omitted. */
  'cs-fleet'?: string;
};
export type RetrieveSafetyEventsV2ApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto
  | /** status 204 No safety events found */ GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto;
export type RetrieveSafetyEventsV2ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty */
  eventTypes?: string[];
  /** Filter events by a specific driver ID. Defaults to all drivers if empty. */
  driverId?: string;
  /** Search for making partial matches to VINs. */
  searchKeyword?: string;
  /** Filters events to only include those with media. */
  hasMedia?: boolean;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type RetrieveSafetyEventDetailsByIdApiResponse =
  /** status 200 Success */ GmResponseCommonSafetyApiEventDetailsV2Dto;
export type RetrieveSafetyEventDetailsByIdApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The ID of the safety event */
  id: string;
};
export type RetrieveSafetyEventsForSelfV2ApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto
  | /** status 204 No safety events found */ GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto;
export type RetrieveSafetyEventsForSelfV2ApiArg = {
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty */
  eventTypes?: string[];
  /** Search for making partial matches to VINs. */
  searchKeyword?: string;
  /** Filters events to only include those with media. */
  hasMedia?: boolean;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type GetDriverScoreDetailsForSelfApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoreDetailsDto;
export type GetDriverScoreDetailsForSelfApiArg = void;
export type GetVehicleScoresApiResponse =
  /** status 200 Success */ GmResponseCommonVehicleScoresResponse;
export type GetVehicleScoresApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Pagination continuation token. */
  'cs-continuation-token'?: string;
  /** Search substring for vehicle VIN. */
  vinSearch?: string;
  /** Minimum score of the vehicle scores. */
  minScore?: number;
  /** Maximum score of the vehicle scores. */
  maxScore?: number;
  /** Exclude vehicles without score (no trips recently). */
  excludeNoScore?: boolean;
  /** ASC or DESC. */
  sortOrder?: 'ASC' | 'DESC';
  /** Page size. */
  size?: number;
};
export type GetDriverScoresSummaryApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoresSummaryDto;
export type GetDriverScoresSummaryApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
};
export type GetScoreApiResponse =
  /** status 200 Success */ GmResponseCommonFleetScoreDto;
export type GetScoreApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet': string;
};
export type GetDriverScoresApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoresResponse;
export type GetDriverScoresApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Pagination continuation token. */
  'cs-continuation-token'?: string;
  /** Search substring for driver name. */
  driverNameSearch?: string;
  /** Minimum score filter (0–100). */
  minScore?: number;
  /** Maximum score filter (0–100). */
  maxScore?: number;
  /** Minimum rank filter. */
  minRank?: number;
  /** Maximum rank filter. */
  maxRank?: number;
  /** Exclude drivers without score (no trips recently). */
  excludeNoScore?: boolean;
  /** ASC or DESC. */
  sortOrder?: 'ASC' | 'DESC';
  /** rank | score | criticalEvents | warningEvents. */
  sortBy?: 'RANK' | 'SCORE' | 'CRITICAL_EVENTS' | 'WARNING_EVENTS';
  /** Page size (min1, max 100, default 20). */
  size?: number;
};
export type GetDriverScoreDetailsApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoreDetailsDto;
export type GetDriverScoreDetailsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** ID of the driver score record. */
  driverScoreId: string;
};
export type Details = {
  /** Location coordinates of the event as [longitude, latitude]. */
  location?: number[];
  /** Gear state of the vehicle during the event. */
  gear?: string;
  /** Odometer reading in kilometers at the time of the event. */
  odometerInKm?: number;
  /** Fuel level as a percentage during the event. */
  fuelLevelInPercent?: number;
  /** Battery charge level as a percentage during the event. */
  chargeInPercent?: number;
  /** State of charge of the battery during the event. */
  stateOfCharge?: number;
  /** Speed of the vehicle in kilometers per hour during the event. */
  speedInKmh?: number;
  /** Duration of prolonged idling in seconds during the event. */
  prolongedIdlingDurationInS?: number;
  /** Following distance in meters during the event. */
  followDistanceInMeters?: number;
  /** Address of the event location. */
  address?: string;
  /** Duration of an idling event in seconds, null if not an idling event */
  durationInSeconds?: number;
  /** Posted speed limit in kilometers per hour, null if not a speedOverPostedLimit event */
  postedSpeedLimitInKmh?: number;
  /**
                        The organization's threshold above the posted speed limit, in kilometers per hour, in effect when
                        the event was detected, null if not a speedOverPostedLimit event. Unrounded, so round it only in
                        the unit it is displayed in: 17.702784 is 11 miles per hour
                         */
  thresholdAboveLimitInKmh?: number;
};
export type Events = {
  /** Unique identifier of the event. */
  eventId: string;
  /** Unique identifier of the asset. */
  assetId?: string;
  /** Source of the event. */
  eventSource: string;
  /** Type of the event. */
  eventType: string;
  /** Formatted timestamp of the event in ISO 8601 format. */
  eventTs: string;
  /** Details of the event. */
  details: Details;
  /** ID used to retrieve the media if it is not null. */
  cameraEventId?: string;
};
export type SafetyTripEventResponseItemDto = {
  /** Unique Identifier of the trip. */
  tripId: string;
  /** List of events for the trip. */
  events: Events[];
  /** Total number of events based on the given filter. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type SafetyTripEventsResponseDto = {
  /** List of trip event response items. */
  items: SafetyTripEventResponseItemDto[];
  /** List of trip IDs that have no safety events. */
  tripsWithoutSafetyEvents: string[];
  /** List of trip IDs that failed fetch from database due to request timeout or any other error. */
  unprocessedTripsIds: string[];
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonSafetyTripEventsResponseDto = {
  result?: SafetyTripEventsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyTripEventsReference = {
  /** Unique identifier for the trip. */
  tripId: string;
  /** Continuation token from the previous response, if applicable. */
  token?: string;
};
export type SafetyTripEventsRequestDto = {
  /** Maximum number of events to be fetched per trip. Defaults to 100. */
  size: number;
  /** If true, the response includes all available details; otherwise it includes location and speedInKmh only. */
  includeAllDetails: boolean;
  /** List of event sources to retrieve, e.g., VEHICLE, CAMERA. */
  safetyEventSource: string[];
  /** List of trips with their IDs and continuation tokens. */
  trips: SafetyTripEventsReference[];
};
export type EventSettingDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
};
export type EventSettingWithSpeedDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Minimum speed threshold in MPH to trigger the event. */
  minSpeedThresholdInMPH: number;
};
export type EventSettingWithSensitivityDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Sensitivity threshold to trigger the event. */
  sensitivityThreshold: 'LOW' | 'MEDIUM' | 'HIGH';
};
export type EventSettingWithDurationDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Idling duration in seconds before the event is triggered. */
  durationInSeconds: number;
};
export type EventSettingsDto = {
  /** Main toggle for all vehicle safety events. */
  vehicleAlerts: EventSettingDto;
  /** Excessive Speeding event settings. */
  excessiveSpeeding: EventSettingWithSpeedDto;
  /** Harsh Braking event settings. */
  harshBraking: EventSettingWithSensitivityDto;
  /** Harsh Acceleration event settings. */
  harshAcceleration: EventSettingWithSensitivityDto;
  /** Harsh Cornering event settings. */
  harshCornering: EventSettingWithSensitivityDto;
  /** Idling event settings. */
  idling: EventSettingWithDurationDto;
};
export type GmResponseCommonEventSettingsDto = {
  result?: EventSettingsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EventSettingsRequest = {
  /** Main toggle for all vehicle safety events. */
  vehicleAlerts?: EventSettingDto;
  /** Excessive Speeding event settings. */
  excessiveSpeeding?: EventSettingWithSpeedDto;
  /** Harsh Braking event settings. */
  harshBraking?: EventSettingWithSensitivityDto;
  /** Harsh Acceleration event settings. */
  harshAcceleration?: EventSettingWithSensitivityDto;
  /** Harsh Cornering event settings. */
  harshCornering?: EventSettingWithSensitivityDto;
  /** Idling event settings. */
  idling?: EventSettingWithDurationDto;
};
export type SafetyApiEventTypeCountDto = {
  /** The safety event type. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Count of events of this type within the window. Zero when none occurred. */
  count: number;
};
export type GmResponseCommonListSafetyApiEventTypeCountDto = {
  result?: SafetyApiEventTypeCountDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyApiEventFleetDto = {
  /** Fleet ID. */
  id?: string;
  /** Fleet name. */
  name?: string;
};
export type SafetyApiDriverDto = {
  /** Identifier of the driver associated with the event. */
  id?: string;
  /** Display name of the driver associated with the event. */
  name?: string;
  /** Email of the driver associated with the event. */
  email?: string;
};
export type SafetyApiEventVehicleDto = {
  /** Vehicle Identification Number */
  vin: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  imageSource?: string;
};
export type SafetyApiEventV2Dto = {
  /** Id of the snapshot safety event. Shared id with peripheral-api if it's a camera event */
  id: string;
  /** Unique Identifier of the trip. */
  tripId?: string;
  /** Fleet that the vehicle belongs to. */
  fleet?: SafetyApiEventFleetDto;
  /** Organization that the vehicle belongs to. */
  orgId: string;
  /** Type of the safety event. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Timestamp of the event. */
  eventDateTime: string;
  /** Driver information enriched from profile-api. */
  driver?: SafetyApiDriverDto;
  /** Vehicle details enriched from asset-service. */
  vehicle: SafetyApiEventVehicleDto;
  /** If media is associated with the event. */
  hasMedia: boolean;
};
export type SafetyApiEventListResponseSafetyApiEventV2Dto = {
  /** Safety Events list. */
  items: SafetyApiEventV2Dto[];
  /** Total number of safety events in result set. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto = {
  result?: SafetyApiEventListResponseSafetyApiEventV2Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Address = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  countryCode?: string;
};
export type SafetyApiEventDetailsV2Dto = {
  /** Id of the safety event */
  id: string;
  /** Id of the trip that the safety event belongs to. It may be null if the trip has not ended yet */
  tripId?: string;
  /** Type of the safety event */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Timestamp of the event */
  eventDateTime: string;
  /** Address information for the event location */
  address?: Address;
  /** Vehicle information */
  vehicle?: SafetyApiEventVehicleDto;
  /** Driver information */
  driver?: SafetyApiDriverDto;
  /** Speed in kilometers per hour at the time of the event */
  speedInKmh?: number;
  /** Duration of an idling event in seconds, null if not an idling event */
  durationInSeconds?: number;
  /** Posted speed limit in kilometers per hour, null if not a speedOverPostedLimit event */
  postedSpeedLimitInKmh?: number;
  /**
                The organization's threshold above the posted speed limit, in kilometers per hour, in effect when the
                event was detected, null if not a speedOverPostedLimit event. Unrounded, so round it only in the unit it
                is displayed in: 17.702784 is 11 miles per hour
                 */
  thresholdAboveLimitInKmh?: number;
  /**
                Indicates if the event has associated media, hasMedia is considered true if cameraEventStatus is READY,
                PROCESSING, or PENDING
                 */
  hasMedia: boolean;
  /**
                External reference to the Peripheral DB cameraEvents container primary id, this is the id used to call
                getMedia API
                 */
  cameraEventId?: string;
  /** Status of the camera event, hasMedia is considered true if cameraEventStatus is READY,
                PROCESSING, or PENDING
                 */
  cameraEventStatus?: 'PENDING' | 'PROCESSING' | 'FAILED' | 'READY' | 'EXPIRED';
  /** Error code of the camera event */
  cameraEventErrorCode?:
    | 'INVALID_STARTTIME'
    | 'DEVICE_OFFLINE'
    | 'UNSUPPORTED_FIRMWARE'
    | 'TIMED_OUT'
    | 'INTERNAL_ERROR'
    | 'NO_CAMERA_ASSOCIATED';
  /**
                The event's location as [longitude, latitude] when stored, plus the stored detail properties that
                safety-api does not model, passed through exactly as stored, so the set of keys varies by event source.
                Properties with a field of their own on this response are not repeated here, and media is never
                included: use cameraEventId and hasMedia.
                 */
  details: {
    [key: string]: any;
  };
};
export type GmResponseCommonSafetyApiEventDetailsV2Dto = {
  result?: SafetyApiEventDetailsV2Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ScoreDataPoint = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Driver score for that date. */
  value: number;
};
export type ScoreDto = {
  /** Current score. */
  value: number;
  /** Delta vs previous score. */
  delta: number;
  /** Chronological score trend. */
  trend: ScoreDataPoint[];
};
export type RankDataPoint = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Rank for that date. */
  value: number;
};
export type RankDto = {
  /** Current rank. */
  value: number;
  /** Total drivers considered for rank. */
  totalDrivers: number;
  /** Delta vs previous rank. */
  delta: number;
  /** Chronological rank trend. */
  trend: RankDataPoint[];
};
export type NormalizedValueDto = {
  /**
                    Normalized value representing events per 1000 miles for count type,
                    or percentage value for percentage type.
                 */
  value?: number;
  /** Normalized type whether it is "count" or "percentage" */
  type?: string;
};
export type ContributingEventDto = {
  /** Event type identifier. */
  type: string;
  /** Count of events of this type. */
  eventCount: number;
  /** Severity classification (CRITICAL/WARNING). */
  severity: string;
  /** Normalized value for this event type. */
  normalized: NormalizedValueDto;
  /** Impact classification (HIGH/LOW). */
  impact: string;
  /** Points delta contribution (positive or negative). */
  pointsDelta: number;
};
export type SeverityPerDayDto = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Critical event count that day. */
  criticalEventCount: number;
  /** Warning event count that day. */
  warningEventCount: number;
};
export type DriverScoreDetailsDto = {
  /** Unique identifier of the driver score record. */
  id: string;
  /** Unique identifier of the driver. */
  driverId?: string;
  /** Driver name. */
  name?: string;
  /** Driver email. */
  email?: string;
  /** Distance driven in miles. */
  distanceInMiles: number;
  /** Score data (current, delta, trend). */
  score?: ScoreDto;
  /** Rank data (current, total drivers, delta, trend). */
  rank?: RankDto;
  /** Total number of critical events. */
  criticalEventCount: number;
  /** Total number of warning events. */
  warningEventCount: number;
  /** List of contributing events sorted by eventCount. */
  contributingEvents: ContributingEventDto[];
  /** Daily severity counts sorted chronologically. */
  severityPerDay: SeverityPerDayDto[];
  /** Value is true when the driver did not drive in the scoring period. */
  isExpired: boolean;
  /** Last update timestamp ISO 8601. */
  updatedAt: string;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type GmResponseCommonDriverScoreDetailsDto = {
  result?: DriverScoreDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleScoreDto = {
  /** Unique identifier of the driver score. */
  id: string;
  /** Unique identifier of the asset, also known as VIN. */
  assetId?: string;
  /** Display name of the vehicle. */
  vehicleName?: string;
  /** Vehicle make, e.g., Chevrolet. */
  vehicleMake?: string;
  /** Vehicle model, e.g. Silverado. */
  vehicleModel?: string;
  /** Vehicle year, e.g., 2020. */
  vehicleYear?: string;
  /** URL of the vehicle image; null if not available. */
  vehicleImageUrl?: string;
  /** Safety score value between 0 and 100. Null if vehicle has no score. */
  score?: number;
  /** Number of critical events in scoring window. */
  criticalEventsCount: number;
  /** Number of warning events in scoring window. */
  warningEventsCount: number;
  /** Value is true when the vehicle has no trips in the scoring period. */
  isExpired: boolean;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type VehicleScoresResponse = {
  /** Vehicle score items list. */
  items: VehicleScoreDto[];
  /** Vehicle score overall total count. */
  total_items?: number;
  /** Continuation token for pagination; null if last page. */
  continuation_token?: string;
};
export type GmResponseCommonVehicleScoresResponse = {
  result?: VehicleScoresResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverScoresSummaryDto = {
  /**
                Average safety score across all drivers in the fleet, weighted by distance driven. Excludes expired driver
                scores. Returns zero if no valid driver scores.
             */
  averageScore: number;
  /** Total count of drivers with scores, excludes expired scores. */
  driverScoresCount: number;
  /** Total count of drivers within org/fleet. */
  totalDriversCount: number;
  /** Total count of vehicles w/o assigned driver that have scores, excludes expired scores. */
  vehicleScoresCount: number;
};
export type GmResponseCommonDriverScoresSummaryDto = {
  result?: DriverScoresSummaryDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TrendItem = {
  /** Date. */
  date?: string;
  /** Value. */
  value?: number;
};
export type ScoreWithTrend = {
  /** Current score value. */
  value?: number;
  /** Delta change from previous period. */
  delta?: number;
  /** Historical trend data. */
  trend?: TrendItem[];
};
export type RankWithTrend = {
  /** Current rank value. */
  value?: number;
  /** Total number of fleets. */
  totalFleets?: number;
  /** Delta change from previous period. */
  delta?: number;
  /** Historical trend data. */
  trend?: TrendItem[];
};
export type EventDetailDto = {
  /** Event type. */
  type?:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Event severity. */
  severity?: 'critical' | 'warning';
};
export type PerformerDto = {
  /** Driver name. */
  name?: string;
  /** Driver score. */
  score?: number;
  /** Driver rank. */
  rank?: number;
  /** Score change/delta. */
  scoreDelta?: number;
  /** Recent event details. Optional field. */
  recentEventTypes?: EventDetailDto[];
};
export type SafetyEventDto = {
  /** Event type. */
  type?:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Value for this event type. */
  value?: number;
  /** Severity of the event. */
  severity?: 'critical' | 'warning';
};
export type CountWithDelta = {
  /** Current count value. */
  value?: number;
  /** Change from previous period. */
  delta?: number;
};
export type FleetScoreDto = {
  /** Organization ID. */
  orgId: string;
  /** Fleet ID. */
  fleetId?: string;
  /** Average driver scores with value, delta, and trend. */
  averageDriverScores?: ScoreWithTrend;
  /** Fleet rankings with value, total fleets, delta, and trend. */
  fleetRankings?: RankWithTrend;
  /** List of bottom performing drivers. */
  bottomPerformers?: PerformerDto[];
  /** List of top performing drivers. */
  topPerformers?: PerformerDto[];
  /** Event values by event type. */
  events?: SafetyEventDto[];
  /** Severity counts per day. */
  severityPerDay?: SeverityPerDayDto[];
  /** Critical event count with delta. */
  criticalEventCount?: CountWithDelta;
  /** Last updated timestamp. */
  updatedAt: string;
};
export type GmResponseCommonFleetScoreDto = {
  result?: FleetScoreDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverScoreDto = {
  /** Unique identifier of the driver score. */
  id: string;
  /** Unique identifier of the driver. */
  driverId?: string;
  /** Leaderboard rank of the driver. Null if driver has no score (e.g., no trips in last 7 days). */
  rank?: number;
  /** Safety score value between 0 and 100. Null if driver has no score. */
  score?: number;
  /** Delta (positive or negative) of score compared to previous calculation window. Null if no trend data available. */
  scoreDelta?: number;
  /** Driver display name. */
  name?: string;
  /** Driver email address. */
  email?: string;
  /** Number of critical events in scoring window. */
  criticalEventsCount: number;
  /** Number of warning events in scoring window. */
  warningEventsCount: number;
  /** Value is true when the driver did not drive in the scoring period. */
  isExpired: boolean;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type DriverScoresResponse = {
  /** Driver score items list. */
  items: DriverScoreDto[];
  /** Driver score overall total count. */
  total_items?: number;
  /** Continuation token for pagination; null if last page. */
  continuation_token?: string;
  /** Latest update timestamp ISO 8601. */
  latestUpdateTimestamp?: string;
};
export type GmResponseCommonDriverScoresResponse = {
  result?: DriverScoresResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useRetrieveSafetyEventsByTripIdsMutation,
  useGetVehicleSettingsQuery,
  useUpdateVehicleSettingsMutation,
  useRetrieveEmergencyEventSummaryQuery,
  useRetrieveSafetyEventsV2Query,
  useRetrieveSafetyEventDetailsByIdQuery,
  useRetrieveSafetyEventsForSelfV2Query,
  useGetDriverScoreDetailsForSelfQuery,
  useGetVehicleScoresQuery,
  useGetDriverScoresSummaryQuery,
  useGetScoreQuery,
  useGetDriverScoresQuery,
  useGetDriverScoreDetailsQuery,
} = injectedRtkApi;
